import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'state/modal/modalSlice';
import style from './FenceElementActions.module.scss';

const FenceElementActions = ({ className = '', id, mode }) => {
  const buttonsRef = useRef(null);
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const editElement = () => {
    setShowDropdown(false);
    dispatch(
      openModal({
        activeName: 'edit-element',
        props: { id },
      })
    );
  };

  const removeElement = () => {
    setShowDropdown(false);
    dispatch(
      openModal({
        activeName: 'remove-element',
        props: { id },
      })
    );
  };

  const addElement = () => {
    setShowDropdown(false);
    dispatch(
      openModal({
        activeName: 'add-element',
        props: { id },
      })
    );
  };

  const clickOutsideHandler = (event) => {
    if (buttonsRef.current && !buttonsRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', clickOutsideHandler, false);

    return () => {
      document.removeEventListener('click', clickOutsideHandler, false);
    };
  }, []);

  return (
    <div className={`${style.buttons} ${style['buttons-' + mode]} ${className}`} ref={buttonsRef}>
      <button type="button" onClick={toggleDropdown} className={`${showDropdown ? 'active' : ''}`}>
        <i className="material-symbols-outlined">more_vert</i>
      </button>
      {(showDropdown || mode === 'default') && (
        <div className={style.buttons_dropdown}>
          <button type="button" title="Szerkesztés" onClick={editElement}>
            <i className="material-symbols-outlined">edit</i>
          </button>
          <button type="button" title="Törlés" onClick={removeElement}>
            <i className="material-symbols-outlined">delete</i>
          </button>
          <button type="button" title="Új elem hozzáadása" onClick={addElement}>
            <i className="material-symbols-outlined">add</i>
          </button>
        </div>
      )}
    </div>
  );
};

export default FenceElementActions;
